import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../../api';
import api from '../../../api/endpoints';

const prepareData = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.id,
      id: item.id,
      invoice: item.description || item.invoice_number,
      date: item.date,
      due_date: item.due_date,
      amount: item.amount_cents / 100,
      status: item.status,
      stripe_url: item.stripe_hosted_invoice_url
    };

    dataTable.push({
      ...el,
      operations: el
    });
  });

  return dataTable;
};

function* getBillingInvoices({ payload: { signal, curr_page } }) {

  try {
    const { data } = yield call(fetch, {
      api: api.billing.invoices,
      params: {
        page: curr_page
      },
      signal
    });

    const preparedData = {
      results: prepareData(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.previous
    };

    yield put(actions.getBillingInvoicesDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getBillingInvoicesFailed,
      endpoint: api.billing.invoices.url
    });
  }
}

export const getBillingInvoicesSaga = takeEvery(types.GET_BILLING_INVOICES_REQUEST, getBillingInvoices);


